const rankingItems = [
  { rank: 1, title: '庆余年第二季', tag: '古装权谋', heat: '9.8', change: 'up', desc: '范闲回归，朝堂风云再起，权谋智斗全面升级' },
  { rank: 2, title: '繁花', tag: '时代剧', heat: '9.7', change: 'up', desc: '王家卫首部剧集，上海滩风云变幻众生相' },
  { rank: 3, title: '狂飙', tag: '刑侦涉案', heat: '9.6', change: 'stable', desc: '扫黑风暴席卷全国，安欣与高启强的终极对决' },
  { rank: 4, title: '三体', tag: '科幻巨制', heat: '9.5', change: 'up', desc: '刘慈欣科幻神作真人化，人类文明存亡之战' },
  { rank: 5, title: '漫长的季节', tag: '悬疑剧情', heat: '9.4', change: 'stable', desc: '东北小城二十年悬案，时间交错中寻找真相' },
  { rank: 6, title: '封神第一部', tag: '神话史诗', heat: '9.2', change: 'up', desc: '中国神话史诗电影里程碑，殷商风云震撼呈现' },
  { rank: 7, title: '周处除三害', tag: '犯罪动作', heat: '9.0', change: 'new', desc: '台湾犯罪片黑马，暴力美学与人性拷问并存' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-3">
            HOT
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            全网热度最高的影视作品实时排行，好片不用找
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 md:gap-5 bg-background-50 rounded-xl px-4 md:px-6 py-4 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl font-heading text-lg md:text-xl font-black ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-primary-400 text-white'
                  : item.rank === 3
                  ? 'bg-primary-300 text-primary-900'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-500 text-xs md:text-sm truncate">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-accent-500 font-bold text-sm md:text-base">{item.heat}</span>
                <span className="w-5 h-5 flex items-center justify-center">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                  {item.change === 'stable' && <i className="ri-subtract-line text-secondary-400 text-sm"></i>}
                  {item.change === 'new' && <i className="ri-sparkling-line text-accent-500 text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}